// src/environments/environment.tst.ts

import { Env } from './environment.model';

const b2cTenantName = 'katarab2c';
const signUpSignInPolicy = 'B2C_1A_SIGNUP_SIGNIN';

export const environment: Env = {
  env: 'tst',
  production: false,
  appInsightsConnectionString:
    'InstrumentationKey=d50fbfc3-5512-46aa-ae47-9d558b817d8e;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=2812f195-26c3-4b98-a722-33381a373d75',
  seo: {
    indexable: false,
    siteName: 'Doctogenic (tst)',

    publisherName: 'Roscoe and Romano',
    publisherUrl: 'https://www.roscoeandromano.com',
    language: 'en-US',
  },
  publicOrigin: 'https://thankful-bay-0ea7b360f.6.azurestaticapps.net',
  gaMeasurementId: 'G-KV76GLKQ8H',

  renderMode: 'ssr-prerender',
  enableHydration: true,

  useStaticContent: true,
  staticBasePath: '/assets/v1',
  apiBaseUrl: '',

  feedbackUrl: 'https://rr-kat-tst-func.azurewebsites.net/api/v1/feedback',

  b2cTenantName,
  signUpSignInPolicy,
  clientId: '6ba8b78a-c4d8-454b-9161-2edbe8a52f3a',

  signUpSignInAuthority:
    `https://${b2cTenantName}.b2clogin.com/` +
    `tfp/${b2cTenantName}.onmicrosoft.com/` +
    `${signUpSignInPolicy}/v2.0`,
};
